import { uniqueId } from "lodash";

import { t } from "@/i18n-js/instance";

const ACCEPTED_IMAGE_TYPES = ["image/gif", "image/jpeg", "image/png"];

export type RemoteImageFetchError = "invalid_type" | "network";

export type FetchRemoteImageResult =
  | { error: RemoteImageFetchError; ok: false }
  | { file: File; ok: true };

export const fetchRemoteImageAsFile = async (
  url: string,
): Promise<FetchRemoteImageResult> => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const contentType = response.headers.get("content-type") ?? "";

    if (!ACCEPTED_IMAGE_TYPES.includes(contentType)) {
      return { ok: false, error: "invalid_type" };
    }

    return {
      ok: true,
      file: new File([blob], uniqueId(), { type: "image/jpeg" }),
    };
  } catch {
    return { ok: false, error: "network" };
  }
};

export const remoteImageFetchErrorMessage = (error: RemoteImageFetchError) =>
  error === "invalid_type"
    ? t("image_upload.invalid_file_type_error")
    : t("image_upload.embed_network_error");
